var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-gr",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 0h512v57H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 57h512v57H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 114h512v57H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 171h512v57H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 228h512v56.9H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 284.9h512v57H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 341.9h512v57H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 398.9h512v57H0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    d: "M0 0h284.9v284.9H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 0h57v284.9h-57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114h284.9v57H0z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#005bae",
    fillRule: "evenodd",
    d: "M0 455h512v57H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.b9742b538eb63f7869aa2b0950988658.svg";
export { ForwardRef as ReactComponent };